import { useEffect, useState } from "react"
import { ChatMsg } from "../models/api/ChatMsg"
import { VChatMsg } from "../models/app/VChatMsg"
import { fetchVNoteAudioUrl } from "../services/HelperService"
import { rootStore } from "../StApp"
import VChatDirectStore from "../stores/VChatDirectStore"
import AudioPlayer from "./ChatAdudioPlayer"
import Loader from "./Loader"

export const VChatUser = (props:{chatId:string, chatMsg: VChatMsg})=>{

    const [voiceUrl, setVoiceUrl] = useState<string|undefined>('')
    useEffect(()=>{

        async function act(){
            let voiceUrl = await fetchVNoteAudioUrl(props.chatId, props.chatMsg.voice!)
            setVoiceUrl(voiceUrl)

        }

        if(props.chatMsg.voice)
         act()
        else if(props.chatMsg.voiceLocalUrl)
         setVoiceUrl(props.chatMsg.voiceLocalUrl) 
        
    },[])

    return(
        <div className='chat-row chat-user ' >
            <div className='chat-item-user'>
                <p className='chat-text' >{props.chatMsg.msg}</p>
                <div style={{height: 10}} ></div>
                <div className='flex-row center-align ' style={{justifyContent: 'space-between'}} >
                    <AudioPlayer voiceUrl={voiceUrl} />
                    <div style={{width: 10}} ></div>
                    <p className='chat-date' >{props.chatMsg.timeOfSending} <br />{props.chatMsg.dateOfSending}</p>
                </div>
            </div>
        </div>
    )
}

export const VChatRecep = (props:{chatId:string, chatMsg: VChatMsg})=>{

    const [voiceUrl, setVoiceUrl] = useState<string|undefined>('')
    useEffect(()=>{

        async function act(){
            let voiceUrl = await fetchVNoteAudioUrl(props.chatId, props.chatMsg.voice!)
            setVoiceUrl(voiceUrl)

        }
        if(props.chatMsg.voice)
         act()
        else if(props.chatMsg.voiceLocalUrl)
         setVoiceUrl(props.chatMsg.voiceLocalUrl) 
        
    },[])

    return(
        <div className='chat-row chat-recep' >
            <div className='chat-item-recep'>
                <p className='chat-text' >{props.chatMsg.msg}</p>
                <div style={{height: 10}} ></div>
                <div className='flex-row center-align ' style={{justifyContent: 'space-between'}} >
                    <AudioPlayer voiceUrl={voiceUrl} />
                    <div style={{width: 10}} ></div>
                    <p className='chat-date' >{props.chatMsg.timeOfSending} <br />{props.chatMsg.dateOfSending} </p>
                </div>
            </div>
        </div>
    )
}

export const VChatComp = (props:{
    store: VChatDirectStore,
    chatMsg: VChatMsg
})=>{

    return(
        <>
        {
            props.chatMsg.senderUid == rootStore.mainStore.uid? 
            <VChatUser chatMsg={props.chatMsg} chatId={props.store.chatId} />: <VChatRecep chatMsg={props.chatMsg} chatId={props.store.chatId} />
        }
        </>
    )
}